import React from 'react';

const SectionTitle = ({ title, description1, description2 }) => {
  return (
    <div className="container section-title" data-aos="fade-up">
      <h2>{title}</h2>
      <div>
        <span>{description1}</span> <span className="description-title">{description2}</span>
      </div>
    </div>
  );
};

export default SectionTitle; 